import Layout from '@/views/layout';

const TrackRouter = {
  path: '/track',
  meta: { title: '跟进记录' },
  component: Layout,
  redirect: { name: 'Track' },
  children: [
    {
      path: 'index',
      name: 'Track',
      component: () => import('@/views/customerManage/track'),
      meta: { title: '跟进记录', noCache: true }
    },
    {
      path: 'create',
      name: 'CreateTrack',
      component: () => import('@/views/customerManage/track/add'),
      meta: { title: '添加跟进记录', noCache: true }
    },
    {
      path: 'recordList',
      name: 'RecordList',
      component: () => import('@/views/customerManage/track/record/recordList'),
      meta: { title: '我可以查看的跟进记录', noCache: true }
    },
    {
      path: 'recordDay',
      name: 'RecordDay',
      component: () => import('@/views/customerManage/track/record/recordDay'),
      meta: { title: '按天查看跟进记录', noCache: true }
    },
    {
      path: 'recordCount',
      name: 'RecordCount',
      component: () => import('@/views/customerManage/track/record/recordCount'),
      meta: { title: '跟进列表统计', noCache: true }
    },
    {
      path: 'trackCustomer',
      name: 'TrackCustomer',
      component: () => import('@/views/customerManage/track/trackCustomer'),
      meta: { title: '跟进客户', noCache: true }
    }
  ]
};

export default TrackRouter;
